import React from 'react';

import { withCars } from '../../../shared/containers/containerCars'

import ButtonCounter from './../../../shared/items/static/buttonCounter'

const CarsBookmarkCounter = props => {
  const { isBookmarkCountUnits } = props

  return (
    <ButtonCounter count={isBookmarkCountUnits} />
  )
}

export default withCars(React.memo(CarsBookmarkCounter))
